import React, {useState, useRef} from 'react';
import { Layout, Button, Card, Tabs, Input, Notification, Loading, Form , Carousel, Tooltip} from 'element-react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

// Asegúrate de que las rutas de las imágenes sean correctas
import sourcingLogo from '../assets/imgs/sourcing_made_easy_logo.png';
import logo from "../assets/imgs/bainub_logo_white.png";
//import HelpAndSupportComponentSeller from '../components/HelpAndSupportComponentSeller';
import iconCircleRed from '../assets/imgs/IconBuyersCircle.png';
import HelpAndSupportComponent from '../components/HelpAndSupportComponent';

import ContactSalesModal from '../components/ContactSalesModal';

import { useTranslation } from 'react-i18next'; // Opcional, pero el otro form lo usa
import * as surveyController from "../graphql/surveyLambdaInvokes"; // Asegúrate que la ruta sea correcta
import sendEmailTemplate from '../graphql/lambdaInvokes'; // Asegúrate que la ruta sea correcta
import * as Constans from '../../src/utils/Constants';

function SellersTools() {

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false)

  const [activeTab, setActiveTab] = useState('2'); 

  const [menuAbierto, setMenuAbierto] = useState(false);

  const [activePlan, setActivePlan] = useState(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab.props.name);
  };

  const [form, setForm] = useState({ fullName: '', email: '', description: '' });
  const onFormChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const formRef = useRef(null);

  const rules = {
    fullName: [
      { required: true, message: 'This field is mandatory', trigger: 'blur' }
    ],
    email: [
      { required: true, message: 'This field is mandatory', trigger: 'blur' },
      { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
    ],
    description: [
      { required: true, message: 'This field is mandatory', trigger: 'blur' }
    ]
  };

  const clearForm = () => {
      setForm({
          fullName: '',
          email: '',
          description: ''
      });

      if (formRef.current) {
        formRef.current.resetFields();
      }
  };

  const handleSubmit = () => {
    formRef.current.validate(async (valid) => {
      if (valid) {
        try {
            console.log('sending seller tools form');
            setLoading(true);

            var saveSurveyResponse = await surveyController.saveSurvey({
                name: form.fullName,
                mail: form.email,
                form_type: 2,
                product_request: form.description,
                company_name: '', phone: '', is_seller: 0, country: '' 
            });

            console.log(saveSurveyResponse);

            await sendEmailTemplate({
                templateName: "form", 
                subject: 'FORMULARIO PRODUCT SELLER TOOLS',
                emailFrom: Constans.FROM_EMAIL,
                recipients: [ "customerservice@bainub.com" ], 
                templateVars: {
                    content: `Full Name: ${form.fullName}<br/>
                              Email: ${form.email}<br/>
                              Product Description: ${form.description}<br/><br/>
                              Date: ${new Date().toLocaleString("en-US", {timeZone: "America/Mexico_City"})}`
                },
                templateLanguage: "en"
            });

            setLoading(false);

            if(saveSurveyResponse.returnCode === 0) {
                console.log("form saved successfully");
                clearForm(); 
                Notification({
                    title: t('home-page.product-survey.confirmation-title'),
                    message: t('home-page.product-survey.confirmation-message'),
                    type: 'success',
                    offset: 100
                });
            } else {
                console.log("form save failed");
                Notification({
                    title: t('home-page.product-survey.confirmation-error-title'),
                    message: t('home-page.product-survey.confirmation-error-message'),
                    type: 'error',
                    offset: 100
                });
            }
        } catch (e) {
            setLoading(false);
            console.error(e);
            Notification({
                title: t('home-page.product-survey.confirmation-error-title'),
                message: t('home-page.product-survey.confirmation-error-message'),
                type: 'error',
                offset: 100
            });
        }
      } else {
        // Si el formulario NO es válido, 'element-react' ya mostró los errores.
        console.log('error submit!!');
        return false;
      }
    });
  };

  const tabContent = [
    { name: "1", title: "What is Bainub B2B?", content: "Bainub is a North American B2B digital platform where you can showcase your company’s manufacturing capabilities and experience to corporate buyers seeking reliable suppliers to build long-term business partnerships." },
    { name: "2", title: "Is my Company suitable for Bainub?", content: "If your company manufactures/distributes products, components, consumables or raw materials, related to any industry, you can benefit from Bainub by showcasing your products to businesses all around North America." },
    { name: "3", title: "What type of buyers source in Bainub?", content: "We have buyers from a wide variety of industries and any business size (from self owned shops to global industries).  Buyers on Bainub are corporate procurement professionals from North American companies who aim to develop new suppliers in Mexico for nearshoring initiatives." },
    { name: "4", title: "Is Bainub Commision Free?", 
      content: (
        <span>
          Bainub works with a fixed subscription service (
          <ScrollLink 
            to="plans-pricing" 
            spy={true} 
            smooth={true} 
            offset={-80} 
            duration={800} 
            className="link-text"
          >
            Plans & Pricing
          </ScrollLink>
          ). We will not charge commisions for your trading operations. We focus in corporate Buyers from North American businesses that want to implement nerashoring strategies, reducing risks and optimizing manufacturing and logistic costs.
        </span>
      )
    }
  ];

  return (
    <>
      { loading && <Loading loading={loading} fullscreen={true} /> }
      <div className='SellersToolsPage'>
        {/* ================= BARRA DE NAVEGACIÓN ================= */}
        {/* --- 1. VERSIÓN DESKTOP --- */}
        {/* Añadimos 'desktop-nav' y quitamos la lógica de 'menuAbierto' */}
        <Layout.Row span="24" className="custom-nav-bar desktop-nav" justify="center" align="middle">
          <Layout.Col className="custom-nav-logo">
            <img src={sourcingLogo} alt="Sourcing Made Easy" />
          </Layout.Col>

          <Layout.Col className="custom-nav-links">
            {/* Quitamos 'onClick' de los links */}
            <ScrollLink to="info-for-sellers" spy={true} smooth={true} offset={-80} duration={500} className="nav-link">
              Info for Sellers
            </ScrollLink>
            <ScrollLink to="benefits-for-sellers" spy={true} smooth={true} offset={-80} duration={500} className="nav-link">
              Benefits for Sellers
            </ScrollLink>
            <ScrollLink to="plans-pricing" spy={true} smooth={true} offset={-80} duration={800} className="nav-link">
              Plans & Pricing
            </ScrollLink>
            <ScrollLink to="faqs" spy={true} smooth={true} offset={-80} duration={800} className="nav-link">
              FAQ'S
            </ScrollLink>
            <Link to="/contact-us">
              <Button className="talk-to-us-button">TALK TO US</Button>
            </Link>
          </Layout.Col>
          {/* (Botón de hamburguesa y 'menuAbierto' logic eliminados) */}
        </Layout.Row>

        {/* --- 2. VERSIÓN MÓVIL (NUEVA) --- */}
        {/* Este es el nuevo componente que solo se verá en móvil */}
        <div className="sellers-nav-bar-mobile">
            <div className="mobile-logo-bar">
                <img src={sourcingLogo} alt="Sourcing Made Easy" />
            </div>
            <div className="mobile-links-scroll">
                <ScrollLink to="info-for-sellers" spy={true} smooth={true} offset={-80} duration={500} className="nav-link">
                    Info for Seller 
                </ScrollLink>
                <ScrollLink to="benefits-for-sellers" spy={true} smooth={true} offset={-80} duration={500} className="nav-link">
                    Benefits 
                </ScrollLink>
                <ScrollLink to="plans-pricing" spy={true} smooth={true} offset={-80} duration={800} className="nav-link">
                    Plans
                </ScrollLink>
                <ScrollLink to="faqs" spy={true} smooth={true} offset={-80} duration={800} className="nav-link">
                    FAQ
                </ScrollLink>
                 {/*<Link to="/contact-us">
                    <Button className="talk-to-us-button">TALK TO US</Button>
                </Link>*/}
            </div>
        </div>

        {/* ================= SECCIÓN: INFO FOR SELLERS (3 PASOS) ================= */}
        <div id="info-for-sellers">
          <Layout.Row className="info-section">
            <Layout.Col span="24" className="section-header">
              <div className="section-title-badge">INFORMATION FOR SELLERS</div>
              {/* Título actualizado y ahora como H1 para mejor semántica */}
              <h1 className="section-main-title">
                CONNECT WITH BUYERS ALL AROUND NORTH AMERICA<br/>
                <span className='title-infoSeller'>Join our B2B Trading Network for Manufaturers</span>
              </h1>
            </Layout.Col>
            <Layout.Col span="24" className="steps-container">
                {/* Paso 1 con texto actualizado */}
                <div className="step-item">
                  <div className="step-number">1.</div>
                  <div className="step-content">
                    <h3 className="step-title">EASILY CREATE A COMPANY MICROSITE</h3>
                    <p className="step-description">Display your production capabilities through professional product ads.</p>
                  </div>
                </div>
                {/* Paso 2 con texto actualizado */}
                <div className="step-item">
                  <div className="step-number">2.</div>
                  <div className="step-content">
                    <h3 className="step-title">CONNECT WITH CORPORATE BUYERS</h3>
                    <p className="step-description">Display your production capabilities through professional product ads.</p>
                  </div>
                </div>
                {/* Paso 3 con texto actualizado */}
                <div className="step-item">
                  <div className="step-number">3.</div>
                  <div className="step-content">
                    <h3 className="step-title">CLOSE & FOLLOW UP AGREEMENTS</h3>
                    <p className="step-description">Display your production capabilities through professional product ads.</p>
                  </div>
                </div>
            </Layout.Col>
          </Layout.Row>
        </div>

        {/* ================= SECCIÓN: PESTAÑAS DE INFORMACIÓN (BENEFITS) ================= */}
        <div id="benefits-for-sellers">
          <Layout.Row className="tabs-info-section">
            <div className="tabs-content-container">
              <Layout.Col span="24">
                <h2 className="section-title">Showcase your Products and Production Expertise</h2>
              </Layout.Col>
              
              {/* --- 3.A. VERSIÓN DESKTOP (TABS) --- */}
              <Layout.Col span="24" className="tabs-container-wrapper desktop-tabs">
                <Tabs activeName={activeTab} onTabClick={handleTabClick} type="card">
                  
                  {tabContent.map(tab => (
                    <Tabs.Pane label={tab.title} name={tab.name} key={tab.name}>
                      <div className="tab-content">
                        <p>{tab.content}</p>
                      </div>
                    </Tabs.Pane>
                  ))}

                </Tabs>
              </Layout.Col>

              {/* --- 3.B. VERSIÓN MÓVIL (CARRUSEL) --- */}
              <Layout.Col span="24" className="mobile-carousel">
                <Carousel autoplay={false} indicator-position="outside">
                  
                  {tabContent.map(tab => (
                    <Carousel.Item key={tab.name}>
                      <div className="carousel-content-item">
                        <h3>{tab.title}</h3>
                        <p>{tab.content}</p>
                      </div>
                    </Carousel.Item>
                  ))}

                </Carousel>
              </Layout.Col>

            </div>
          </Layout.Row>
        </div>

        {/* ================= SECCIÓN: IS MY PRODUCT SUITABLE ================= */}
        <div id="product-suitable">
          <Layout.Row className="product-suitable-section">
            <Layout.Col span="24">
              <h2 className="section-title">IS MY PRODUCT SUITABLE FOR BAINUB?</h2>
              <p className="section-description">
                Our B2B manufacturing marketplace is built for every industry, from raw materials and components to machinery, tools, packaging, and finished goods. Whether you serve automotive, aerospace, construction, food, or medical sectors, you’ll be in the perfect place to connect with interested buyers.
              </p>

              <div className="category-group">
                <span className="group-label">Product Types</span>
                <div className="category-grid">
                  <div className="category-item">Raw Materials</div>
                  <div className="category-item">Intermediate Goods</div>
                  <div className="category-item">Finished Products</div>
                </div>
              </div>

              <div className="category-group">
                <span className="group-label">Bainub Product Categories</span>
                <div className="category-grid large">
                  <div className="category-item">Advertising, Packaging & Printing</div>
                  <div className="category-item">Agriculture & Food</div>
                  <div className="category-item">Apparel & Textiles</div>
                  <div className="category-item">Chemical, Materials & Energy</div>
                  <div className="category-item">Construction & Decoration</div>
                  <div className="category-item">Electrical & Electronics</div>
                  <div className="category-item">Houseware & Office Supplies</div>
                  <div className="category-item">Health & Personal Care</div>
                  <div className="category-item">Industrial Equipment</div>
                  <div className="category-item">Metals & Metal Products</div>
                  <div className="category-item">Plastic & Rubber</div>
                  <div className="category-item">Sports & Recreation</div>
                  <div className="category-item">Security & Protection</div>
                  <div className="category-item">Transports & Parts</div>
                </div>
              </div>

              <div className="suitable-form-container">
                <p className="form-cta">
                  <span className="cta-question">Not sure if your product is suitable?</span> Send us a message and we will advice.
                </p>
                <Form ref={formRef} model={form} rules={rules} className="form-inputs">
              
              {/* Cada Input va dentro de un Form.Item */}
                <Form.Item prop="fullName">
                  <Input 
                    placeholder="Full Name" 
                    value={form.fullName} 
                    onChange={(val) => onFormChange('fullName', val)} 
                  />
                </Form.Item>

                <Form.Item prop="email">
                  <Input 
                    placeholder="E-mail" 
                    value={form.email} 
                    onChange={(val) => onFormChange('email', val)} 
                  />
                </Form.Item>
                
                <Form.Item prop="description" className="description-input">
                  <Input 
                    placeholder="Product Description" 
                    value={form.description} 
                    onChange={(val) => onFormChange('description', val)} 
                     
                  />
                </Form.Item>
                
                <Button 
                  className="send-button"
                  onClick={handleSubmit} 
                  loading={loading}
                >
                  SEND
                </Button>

              </Form>
              </div>

            </Layout.Col>
          </Layout.Row>
        </div>

        {/* ================= SECCIÓN: BAINUB TOOLS FOR SELLERS ================= */}
        <div id="tools-for-sellers">
          {/* 1. Usamos la misma clase que Buyers para heredar los estilos */ }
          <Layout.Row className="bainub-tools-section"> 
            
            {/* --- Columna Izquierda (Contenido) --- */}
            <Layout.Col xs="24" md="12" className="tools-description-col">
              <div className="section-title-badge">BAINUB TOOLS FOR SELLERS</div>
              
              {/* 2. Reconstruimos la lista con la estructura de Buyers (icono + div) */}
              <ul className="tools-list">
                <li>
                  <img src={iconCircleRed} alt="icon" className="list-icon" />
                  <div>
                    <h4>Create your Company Microsite</h4>
                    <p>Publish a microsite in Bainub to show your company profile and basic information to interested buyers. Our Microsite Wizard will guide you to get it ready easily in just minutes.</p>
                  </div>
                </li>
                <li>
                  <img src={iconCircleRed} alt="icon" className="list-icon" />
                  <div>
                    <h4>Create Product Ads</h4>
                    <p>Publish an Ad for each product you want to promote in Bainub. This is the way Buyers will get to know your what you can do. Its quick and easy, anyone can create Ads in Bainub using our Product Wizzard.</p>
                  </div>
                </li>
                <li>
                  <img src={iconCircleRed} alt="icon" className="list-icon" />
                  <div>
                    <h4>Bainub Message Center</h4>
                    <p>Receive messages from interested customers and scale up negotiations using our Message Center.</p>
                  </div>
                </li>
                <li>
                  <img src={iconCircleRed} alt="icon" className="list-icon" />
                  <div>
                    <h4>RFQ Direct</h4>
                    <p>Browse the RFQ list to submit proposals to buyers actively looking for suppliers in your area of expertise.</p>
                  </div>
                </li>
                <li>
                  <img src={iconCircleRed} alt="icon" className="list-icon" />
                  <div>
                    <h4>Closed Sale? Follow up with Trade Agreements</h4>
                    <p>Create, share and update your Trade Agreements with a live document that will help you follow up and communicate each step of the project with your business partner.</p>
                  </div>
                </li>
              </ul>
              {/* 3. El botón de "Get Started" no estaba en tu diseño original, así que no lo agregamos. */}
            </Layout.Col>
            
            {/* --- Columna Derecha (Video) --- */}
            {/* 4. Copiamos la columna del video de BuyersTools */}
            <Layout.Col xs="24" md="12" className="video-col">
              <div className="responsive-iframe-container">
                <iframe
                    src={'https://www.youtube.com/embed/nZYHpFxR4EQ?si=QM8t-j_gKMLXVjGC'}
                    title="Bainub North American B2B Marketplace" // Título actualizado
                    frameBorder="0"
                    allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
              </div>
            </Layout.Col>
          </Layout.Row>
        </div>

        {/* ================= SECCIÓN: PLANS & PRICING (CORREGIDO) ================= */}
        <div id="plans-pricing">
          <Layout.Row className="pricing-section-new">
            
            <div className="pricing-cards-container-new">
              
              {/* --- Tarjeta FREE --- */}
              <div className="pricing-card-new">
                <h3>Free</h3>
                <p className="plan-subtitle">Ideal for new sellers looking to create a profile and start connecting.</p>
                
                <ul className="plan-features price-list">
                  <li>
                    <div>
                      <span className="price-label">Annual Billing</span>
                      <span className="price-value">$0.00<span className="currency"> MX</span></span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <span className="price-label">Monthly Billing</span>
                      <span className="price-value">$0.00<span className="currency"> MX</span></span>
                    </div>
                  </li>
                </ul>
                <div className="try-free-promo spacer">
                   Try it free! (limited time)
                </div>
                <Link to="/login">
                  <Button className="plan-button">Join Free</Button>
                </Link>

                {/* La lista completa de features */}
                <ul className="full-features-list">
                  <li><span className="custom-check"></span> All Buyer Tools Enabled</li>
                  <li><span className="custom-check"></span> Microsite for your Company with product list</li>
                  <li><span className="custom-check"></span> Message Center for Instant Communication</li>
                </ul>
              </div>

              {/* --- Tarjeta PREMIUM (Popular) --- */}
              <div className="pricing-card-new popular">
                <div className="popular-badge">MOST POPULAR</div>
                <h3>Premium</h3>
                <p className="plan-subtitle">For growing businesses ready for unlimited products and RFQ access.</p>
                
                <ul className="plan-features price-list">
                  <li>
                    <span className="feature-icon icon-user">
                      <i className="fas fa-calendar-alt"></i>
                    </span>
                    <div>
                      <span className="price-label">Annual Billing</span>
                      <span className="price-value"><del>$3,495<span className="currency"> MX/MONTH</span></del></span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <span className="price-label">Monthly Billing</span>
                      <span className="price-value"><del>$3,995<span className="currency"> MX</span></del></span>
                    </div>
                  </li>
                </ul>
                <div className="try-free-promo">
                  Try it free! (limited time)
                  
                  <Tooltip effect="dark" content="Enjoy full access at no cost during our limited-time promotion." placement="top">
                    <span className="info-icon-svg">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                      </svg>
                    </span>
                  </Tooltip>

                </div>
                <Button className="plan-button" onClick={() => setActivePlan('Premium')}>Contact Sales</Button>

                <ul className="full-features-list">
                  <li><span className="custom-check"></span> All Buyer Tools Enabled</li>
                  <li><span className="custom-check"></span> Microsite for your Company</li>
                  <li><span className="custom-check"></span> Message Center for Instant Communication</li>
                  <li><span className="custom-check"></span> 25 Product Listings</li>
                  <li><span className="custom-check"></span> Unlimited Issue Trade Agreements</li>
                  <li><span className="custom-check"></span> RFQ Direct Access</li>
                  <li><span className="custom-check"></span> Premium Company Badge</li>
                  <li><span className="custom-check"></span> Front Page Advertising</li>
                  <li><span className="custom-check"></span> Bainub Assist - 3 product upload / month</li>
                </ul>
              </div>

              {/* --- Tarjeta ENTERPRISE --- */}
              <div className="pricing-card-new">
                <h3>Enterprise</h3>
                <p className="plan-subtitle">Comprehensive plan for established teams needing multiple accounts & analytics.</p>
                
                <ul className="plan-features price-list">
                  <li>
                    <div>
                      <span className="price-label">Annual Billing</span>
                      <span className="price-value">$6,355<span className="currency"> MX/MONTH</span></span>
                    </div>
                  </li>
                  <li>
                    <span className="feature-icon icon-credit">
                      <i className="fas fa-calendar-day"></i>
                    </span>
                    <div>
                      <span className="price-label">Monthly Billing</span>
                      <span className="price-value">$7,495<span className="currency"> MX</span></span>
                    </div>
                  </li>
                </ul>
                <div className="try-free-promo spacer">
                  Try it free! (limited time)
                  
                  <Tooltip effect="dark" content="Enjoy full access at no cost during our limited-time promotion." placement="top">
                    <span className="info-icon-svg">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                      </svg>
                    </span>
                  </Tooltip>

                </div>
                <Button className="plan-button" onClick={() => setActivePlan('Enterprise')}>Contact Sales</Button>


                <ul className="full-features-list">
                  <li><span className="custom-check"></span> All Buyer Tools Enabled</li>
                  <li><span className="custom-check"></span> Microsite for your Company</li>
                  <li><span className="custom-check"></span> Message Center for Instant Communication</li>
                  <li><span className="custom-check"></span> 100 Product Listings</li>
                  <li><span className="custom-check"></span> Unlimited Issue Trade Agreements</li>
                  <li><span className="custom-check"></span> RFQ Direct Access</li>
                  <li><span className="custom-check"></span> Premium Company Badge</li>
                  <li><span className="custom-check"></span> Targeted Front Page Advertising</li>
                  <li><span className="custom-check"></span> Bainub Assist - 100 product upload</li>
                  <li><span className="custom-check"></span> Analytics</li>
                  <li><span className="custom-check"></span> 5 seller accounts</li>
                </ul>
              </div>

            </div>
          </Layout.Row>
        </div>

        {/* ================= SECCIÓN: FAQ ================= */}
        <div id="faqs">
          <Layout.Row className="faq-section"> 
            <Layout.Col span="24">
              {/* Título de la sección */}
              <h2 className="section-title">SELLER FAQ</h2> 
              <div className='faq-section-container'>
                <Card className="faq-card-container"> 
                  <HelpAndSupportComponent menu={false} /> 
                </Card>
              </div>
            </Layout.Col>
          </Layout.Row>
        </div>
        
        {/* ================= SECCIÓN: CTA FOOTER ================= */}
        <div>
          <div className='TalkContainer'>
              <div className='TalktoUs'>
                  <Layout.Row>
                      <Layout.Col sm="24" md="16" lg="16">
                          <h2>Talk to us</h2>
                          <p>if you have any questions about the team, culture or values, we’re an open book, just contact us!</p>
                      </Layout.Col>
                      <Layout.Col sm="24" md="8" lg="8">
                          <div className='responsiveSpacer'></div>
                          <Link to="/contact-us">
                              <div className='button'>
                                  More Information
                              </div>
                          </Link>
                      </Layout.Col>
                  </Layout.Row>
              </div>
          </div>
          <Layout.Row className='section03'>
              <Layout.Col xs="24" sm="24" md="18" lg="18" offset="3">
                  <h3>Ready to grow? Sign Up Now!</h3>
                  <img src={logo} alt="Bainub Logo" />
              </Layout.Col>
          </Layout.Row>
      </div>
      <ContactSalesModal 
        visible={activePlan !== null} 
        planType={activePlan}
        onClose={() => setActivePlan(null)}
      />
      </div>
    </>
  )
}

export default SellersTools;